import { View, Text, Modal, StyleSheet } from "react-native";
import React from "react";

export default function ModalComponent({
  isVisible,
  children,
  toggleModal,
}: {
  isVisible: boolean;
  children: React.ReactNode;
  toggleModal: () => void;
}) {
  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={isVisible}
      onRequestClose={toggleModal}
    >
      {children}
    </Modal>
  );
}
const styles = StyleSheet.create({});
